import { Support } from "@/pages/dashboard/Support";
import { ActiveSessions } from "../components/Dashboard/account-page/ActiveSessions";
import { BasicInfo } from "../components/Dashboard/account-page/BasicInfo";
import { ChangePassword } from "../components/Dashboard/account-page/ChangePasssword";
import { CloseAccount } from "../components/Dashboard/account-page/CloseAccount";
import { Kyc } from "../components/Dashboard/account-page/Kyc";
import { PaymentDetails } from "../components/Dashboard/account-page/PaymentDetails";
import { TwoFactorSecurity } from "../components/Dashboard/account-page/TwoFactorSecurity";
import History from "../components/Dashboard/quick-sell/history";
import { SellBitcoin } from "../components/Dashboard/quick-sell/SellBitcoin";
import { SellUsdt } from "../components/Dashboard/quick-sell/SellUsdt";
import { NetworkPicker } from "../components/Dashboard/quick-sell/NetworkPicker";
import { OrderDetails } from "../components/Dashboard/transactions/OrderDetails";
import { OrdersTablePanel } from "../components/Dashboard/transactions/OrdersTablePanel";
import { TradeDetails } from "../components/Dashboard/transactions/TradeDetails";
import { TradesTablePanel } from "../components/Dashboard/transactions/TradesTablePanel";
import { WithdrawDetails } from "../components/Dashboard/transactions/WithdrawDetails";
import { WithdrawsTablePanel } from "../components/Dashboard/transactions/WithdrawsTablePanel";
import { BillsTransactionDetails } from "../components/Dashboard/bills/BillsTransactionDetails";
import { VerifyEmail } from "../components/LandingPage/Register/VerifyEmail";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { EmptyLayout } from "../layouts/EmptyLayout";
import Redirect from "../layouts/Redirector";
import { CloseAccountOTP } from "../pages/CloseAccountOTP";
import { AccountPage } from "../pages/dashboard/AccountPage";
import { Announcements } from "../pages/dashboard/Announcements";
import { Chat } from "../pages/dashboard/Chat";
import { GiftCardPage } from "../pages/dashboard/GiftCardPage";
import { HomePage } from "../pages/dashboard/HomePage";
import { QuickSell } from "../pages/dashboard/QuickSell";
import { BillsPage } from "../pages/dashboard/BillsPage";
import { BuyGiftcardsPage } from "../pages/dashboard/BuyGiftcardsPage";
import { Transaction } from "../pages/dashboard/Transaction";
import { Tutorial } from "../pages/dashboard/Tutorial";
import { UsdtWallet } from "../pages/dashboard/UsdtWallet";
import { WithdrawNow } from "../pages/dashboard/WithdrawNow";
import CryptoPayout from "../pages/dashboard/CryptoPayout";
import CryptoPayoutDetails from "../pages/dashboard/CryptoPayoutDetails";
import MomoWithdraw from "../pages/dashboard/MomoWithdraw";
import { ForgotPassword } from "../pages/ForgotPassword";
import { Login } from "../pages/Login";
import { Register } from "../pages/Register";
import { SecureAccount } from "../pages/SecureAccount";
import { LoginConfirm } from "../pages/LoginConfirm";
import { Leaderboards } from "@/pages/dashboard/Leaderboards";
import { LeaderboardRewards } from "@/pages/dashboard/LeaderboardRewards";
import { RateAlerts } from "@/pages/dashboard/RateAlerts";
import Referral from "@/pages/dashboard/Referral";
import { TransactionHistory } from "@/pages/dashboard/TransactionHistory";
import { Levels } from "@/pages/dashboard/Levels";
import { Deposit } from "@/pages/dashboard/Deposit";
import { EmailSubscription } from "@/pages/dashboard/EmailSubscription";
import { Analytics } from "@/pages/dashboard/Analytics";
import { VipTrading } from "@/pages/dashboard/VipTrading";
import { TreasuryChestPage } from "@/pages/dashboard/TreasuryChestPage";

interface IRoute {
  path: string;
  element: JSX.Element;
  children?: IRoute[];
}

export const routes: IRoute[] = [
  {
    path: "/",
    element: <Redirect />,
  },
  {
    path: "/login",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <Login />,
      },
    ],
  },
  {
    path: "/register",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <Register />,
      },
    ],
  },
  {
    path: "/verify-email",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <VerifyEmail />,
      },
    ],
  },
  {
    path: "/password/reset",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <ForgotPassword />,
      },
    ],
  },
  {
    path: "/auth/secure-account",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <SecureAccount />,
      },
    ],
  },
  {
    path: "/auth/login-confirm",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <LoginConfirm />,
      },
    ],
  },
  {
    path: "/close-account",
    element: <EmptyLayout />,
    children: [
      {
        path: "",
        element: <CloseAccountOTP />,
      },
    ],
  },
  {
    path: "/app",
    element: <DashboardLayout />,
    children: [
      {
        path: "home",
        element: <HomePage />,
      },
      {
        path: "levels",
        element: <Levels />,
      },
      {
        path: "leaderboards",
        element: <Leaderboards />,
      },
      {
        path: "leaderboards/rewards",
        element: <LeaderboardRewards />,
      },
      {
        path: "rate-alerts",
        element: <RateAlerts />,
      },
      {
        path: "announcements",
        element: <Announcements />,
      },
      {
        path: "referrals",
        element: <Referral />,
      },
      // {
      //   path: 'bitcoin-wallet',
      //   element: <BitcoinWallet />,
      // },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "usdt-wallet",
        element: <UsdtWallet />,
      },
      {
        path: "giftcard",
        element: <GiftCardPage />,
      },
      {
        path: "bills",
        element: <BillsPage />,
      },
      {
        path: "bills/transactions/:requestId",
        element: <BillsTransactionDetails />,
      },
      {
        path: "buy-giftcards",
        element: <BuyGiftcardsPage />,
      },
      {
        path: "tutorial",
        element: <Tutorial />,
      },
      {
        path: "quick-sell",
        element: <QuickSell />,
        children: [
          {
            path: "usdt",
            element: <NetworkPicker coin="usdt" />,
          },
          {
            path: "usdt/tron",
            element: <SellUsdt />,
          },
          {
            path: "usdc",
            element: <NetworkPicker coin="usdc" />,
          },
          {
            path: "history",
            element: <History />,
          },
          {
            path: ":coin",
            element: <SellBitcoin />,
          },
        ],
      },
      {
        path: "transaction-history",
        element: <TransactionHistory />,
      },
      {
        path: "transaction",
        element: <Transaction />,
        children: [
          {
            path: "orders",
            element: <OrdersTablePanel />,
          },
          {
            path: "trades",
            element: <TradesTablePanel />,
          },
          {
            path: "withdraws",
            element: <WithdrawsTablePanel />,
          },
        ],
      },
      {
        path: "transaction/orders/:id",
        element: <OrderDetails />,
      },
      {
        path: "transaction/trades/:id",
        element: <TradeDetails />,
      },
      {
        path: "transaction/withdraws/:id",
        element: <WithdrawDetails />,
      },
      // {
      //   path: 'trade',
      //   element: <Trade />,
      //   children: [
      //     { path: 'usdt', element: <TradeUSDT /> },
      //     { path: 'bitcoin', element: <TradeBitcoin /> },
      //   ],
      // },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "withdraw",
        element: <WithdrawNow />,
      },
      {
        path: "crypto-payout",
        element: <CryptoPayout />,
      },
      {
        path: "crypto-payout/:id",
        element: <CryptoPayoutDetails />,
      },
      {
        path: "momo-withdraw",
        element: <MomoWithdraw />,
      },
      {
        path: "deposit",
        element: <Deposit />,
      },
      {
        path: "email-subscription",
        element: <EmailSubscription />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "vip-trading",
        element: <VipTrading />,
      },
      {
        path: "treasury-chest",
        element: <TreasuryChestPage />,
      },
      {
        path: "account",
        element: <AccountPage />,
        children: [
          {
            path: "basic-info",
            element: <BasicInfo />,
          },
          {
            path: "change-password",
            element: <ChangePassword />,
          },
          {
            path: "two-factor-security",
            element: <TwoFactorSecurity />,
          },
          {
            path: "payment-details",
            element: <PaymentDetails />,
          },
          {
            path: "active-sessions",
            element: <ActiveSessions />,
          },
          {
            path: "close",
            element: <CloseAccount />,
          },
          {
            path: "kyc",
            element: <Kyc />,
          },
        ],
      },
    ],
  },
];
